import { officeApi } from "../api/config";
import {
  ProjectBasicDataType,
  ProjectType,
  MeetupType,
  MeetupBasicDataType,
  MagazineType,
} from "../interface/interface";

export var reg = new RegExp(/[\{\}\[\]\?.,;:|\)*~`!^-_+<>@\#$%&\\\=\(\'\"]/gi);

type FileType = {
  url: string;
  name: string;
};

let selection: any;

export const SetSelection = (e: Range) => {
  selection = e;
};
export const GetSelection = () => {
  return selection;
};

export function FileChangeUrl(file: File): Promise<{ url: string }> {
  return new Promise((resolve, reject) => {
    const form = new FormData();
    form.append("file", file);
    officeApi
      .post("/cm/atch/file/20230004/1/upload", form)
      .then(({ data }) => {
        if (data) {
          resolve({
            url: data.file_dwn_url,
            // name: file.name,
          });
        }
      })
      .catch((err) => {
        reject(err);
      });
  });
}

export type DetailReturnType =
  | "refund-ready-state"
  | "refund-finish-state"
  | "wait-state"
  | "success-state"
  | "cancel-state"
  | "reject-state"
  | "select-wait-state";

export const PaymnetDetailForm = (
  prjt_type_cd: "prjt" | "mtup",
  prjt_sts_cd: string,
  apprv_sts_cd: string,
  apply_sts_cd: string,
  rcrt_paysts_cd: string
): DetailReturnType => {
  if (prjt_type_cd === "prjt") {
    if (rcrt_paysts_cd === "ref_req") {
      return "refund-ready-state";
    } else if (rcrt_paysts_cd === "ref_res") {
      return "refund-finish-state";
    } else if (
      prjt_sts_cd === "prjt_sts_rcrt_ing" &&
      apply_sts_cd === "apply_sts_wait"
    ) {
      return "wait-state";
    } else if (rcrt_paysts_cd === "pay_suss") {
      return "success-state";
    } else if (
      apply_sts_cd === "apply_sts_cancel" &&
      rcrt_paysts_cd === "pay_wait"
    ) {
      return "cancel-state";
    } else if (
      apprv_sts_cd === "apprv_sts_reject" &&
      rcrt_paysts_cd === "pay_wait"
    ) {
      return "reject-state";
    } else {
      return "select-wait-state";
    }
  } else {
    if (rcrt_paysts_cd === "ref_req") {
      return "refund-ready-state";
    } else if (rcrt_paysts_cd === "ref_res") {
      return "refund-finish-state";
    } else if (rcrt_paysts_cd === "pay_suss") {
      return "success-state";
    } else {
      return "cancel-state";
    }
  }
};
type ChargeType = {
  text: string;
  amt: number;
  type: string;
};

export type StateFormReturnType = {
  type:
    | "wait"
    | "refund-ready"
    | "refund-complete"
    | "refund"
    | "cancel-complete"
    | "reject"
    | "success"
    | "";
  text: string;
};

export const PaymentStateForm = (
  prjt_type_cd: "prjt" | "mtup",
  prjt_sts_cd: string,
  apprv_sts_cd: string,
  apply_sts_cd: string,
  rcrt_paysts_cd: string
): StateFormReturnType => {
  if (prjt_type_cd === "prjt") {
    if (rcrt_paysts_cd === "ref_req") {
      return {
        type: "refund-ready",
        text: "환불요청",
      };
    } else if (rcrt_paysts_cd === "ref_res") {
      return {
        type: "refund-complete",
        text: "환불완료",
      };
    } else if (
      prjt_sts_cd === "prjt_sts_rcrt_ing" &&
      apply_sts_cd === "apply_sts_wait"
    ) {
      return {
        type: "wait",
        text: "결제대기",
      };
    } else if (rcrt_paysts_cd === "pay_suss") {
      return {
        type: "success",
        text: "결제완료",
      };
    } else if (apply_sts_cd === "apply_sts_cancel") {
      return {
        type: "cancel-complete",
        text: "취소",
      };
    } else if (apprv_sts_cd === "apprv_sts_reject") {
      return {
        type: "reject",
        text: "거절",
      };
    } else if (
      prjt_sts_cd !== "prjt_sts_rcrt_ing" &&
      apply_sts_cd === "apply_sts_wait"
    ) {
      return {
        type: "",
        text: "선정대기",
      };
    } else {
      return {
        type: "reject",
        text: "미선정",
      };
    }
  } else {
    if (rcrt_paysts_cd === "ref_req") {
      return {
        type: "refund-ready",
        text: "환불요청",
      };
    } else if (rcrt_paysts_cd === "ref_res") {
      return {
        type: "refund-complete",
        text: "환불완료",
      };
    } else if (rcrt_paysts_cd === "pay_suss") {
      return {
        type: "refund",
        text: "결제완료",
      };
    } else {
      return {
        type: "",
        text: "미결제",
      };
    }
  }
};

export const ChargeChange = (
  pay_time: string,
  paym_amt: number,
  type: "prjt" | "mtup",
  finish_time: string,
  cancel_time: string
): ChargeType => {
  const payDate = new Date(pay_time);
  payDate.setHours(0);
  payDate.setMinutes(0);
  payDate.setSeconds(0);
  const nowDate = new Date(cancel_time);
  nowDate.setHours(0);
  nowDate.setMinutes(0);
  nowDate.setSeconds(0);
  const payNumber = ChangeDateNumber(payDate);
  const nowNumber = ChangeDateNumber(nowDate);
  if (payNumber === nowNumber) {
    return {
      type: "all",
      text: "결제당일",
      amt: 0,
    };
  } else {
    let subDate = payDate;
    if (type === "mtup") {
      subDate = new Date(finish_time);
      subDate.setHours(0);
      subDate.setMinutes(0);
      subDate.setSeconds(0);
    } else {
      subDate.setDate(payDate.getDate() + 2);
    }
    const subNumber = ChangeDateNumber(subDate);

    if (nowNumber <= subNumber) {
      return {
        type: "charge",
        amt: (paym_amt / 100) * 20,
        text: `결제 다음날 ~ ${
          type === "prjt" ? "프로젝트" : "밋업"
        } 하루전까지`,
      };
    } else {
      return {
        type: "no-refund",
        amt: 0,
        text: `${type === "prjt" ? "결제일 +2일 이후" : "밋업 당일 이후"}`,
      };
    }
  }
};

const ChangeDateNumber = (date: Date) => {
  return Number(
    date.getFullYear() + "" + (date.getMonth() + 1) + "" + date.getDate()
  );
};
export const Fileread = (file: File): Promise<FileType> => {
  return new Promise((resolve, reject) => {
    var reader = new FileReader();
    reader.onload = function (e) {
      const imageUrl = e?.target?.result;
      if (typeof imageUrl === "string") {
        var img = new Image();
        img.src = imageUrl;
        img.onload = function (e) {
          officeApi
            .post("/web/cmnt/2/ctts/img", [{ img_src: imageUrl }])
            .then(({ data: { succ_obj } }) => {
              resolve({
                url: succ_obj[0].img_url,
                name: file.name,
              });
            })
            .catch((err) => {
              reject(err);
            });
        };
      }
    };
    reader.readAsDataURL(file);
  });
};

export function refundTime(date: number | string) {
  var d = new Date(date),
    month = "" + (d.getMonth() + 1),
    day = "" + d.getDate();

  if (parseInt(month) < 10) month = "0" + month;
  if (parseInt(day) < 10) day = "0" + day;
  return `${month}월 ${day}일`;
}

export function formatDate(date: number | string, type: string) {
  var d = new Date(date),
    month = "" + (d.getMonth() + 1),
    day = "" + d.getDate(),
    year = d.getFullYear();
  if (parseInt(month) < 10) month = "0" + month;
  if (parseInt(day) < 10) day = "0" + day;
  return [year, month, day].join(type);
}
export function DdayChange(e: string) {
  const recheckTime = new Date(e);
  recheckTime.setHours(0);
  const Dday =
    Math.floor((recheckTime.getTime() - Date.now()) / (1000 * 60 * 60 * 24)) +
    1;
  return Dday;
}

export function formatDateTime(date: number, type: string) {
  var d = new Date(date),
    month = "" + (d.getMonth() + 1),
    day = "" + d.getDate(),
    year = d.getFullYear(),
    hour = String(d.getHours()),
    minutes = String(d.getMinutes());

  if (parseInt(month) < 10) month = "0" + month;
  if (parseInt(day) < 10) day = "0" + day;
  if (parseInt(hour) < 10) hour = "0" + hour;
  if (parseInt(minutes) < 10) minutes = "0" + minutes;

  return `${[year, month, day].join(type)} ${hour}:${minutes}`;
}

export function makeComma(str: string | number) {
  const number = String(str).replace(/[^0-9]/gi, "");
  return String(number).replace(/(\d)(?=(?:\d{3})+(?!\d))/g, "$1,");
}

export function PeriodForm(text: string) {
  const number = text.replace(/[^0-9]/gi, "");
  return number.replace(/(\d{4})(\d{2})(\d{2})/, "$1-$2-$3");
}

export function StateForm(text: string) {
  const form = {
    prjt_sts_end: "종료",
    prjt_sts_rcrt_ing: "모집중",
    prjt_sts_tmp: "임시저장",
    prjt_sts_rcrt_paus: "일시정지",
  };

  return form[text as keyof typeof form];
}

export function ProjectDataChange(data: ProjectType, template: string) {
  const {
    mainimg,
    title,
    price,
    period: { start, finish },
    category,
    field: { rough, detail },
    leader: { id, img, title: leaderTitle, sub, link, name, intro },
    pnlt_lst,
    rewards,
    finish_time,
  } = data;
  const rcrt = detail.map((item) => {
    let clone = Object.assign({}, item);
    clone.attd_amt = Number(price ? price.replaceAll(",", "") : 0);
    return clone;
  });
  return {
    prjt_nm: title,
    prjt_thumbnail: mainimg,
    prjt_type_nm: "프로젝트",
    prjt_type_cd: "prjt",
    prjt_ctts: template,
    prjt_apply_st_at: new Date(finish_time),
    rcrt_nm_agg: rough,
    prjt_desc: "비고",
    prjt_ctg_cd: category,
    prjt_sort_no: 99,
    leadr_usr_id: id,
    leadr_usr_nm: name,
    leadr_brif: sub,
    leadr_ptfo_tit: leaderTitle,
    leadr_ptfo_ctts: intro,
    leadr_ptfo_link: link,
    leadr_thumbnail: img,
    rcrt_lst: rcrt,
    rwrd_lst: rewards,
    pnlt_lst,
    rcrt_apply_st_at: start ? new Date(start) : "",
    rcrt_apply_en_at: finish ? new Date(finish) : "",
  };
}

export function FixProjectDataChange(data: ProjectBasicDataType) {
  const {
    prjt_id,
    prjt_nm,
    prjt_thumbnail,
    prjt_apply_st_at,
    prjt_type_cd,
    rcrt_nm_agg,
    prjt_ctts,
    prjt_desc,
    leadr_usr_id,
    leadr_usr_nm,
    leadr_brif,
    leadr_thumbnail,
    prjt_ctg_cd,
    leadr_ptfo_tit,
    leadr_ptfo_ctts,
    leadr_ptfo_link,
    rcrt_apply_st_at,
    rcrt_apply_en_at,
    rcrt_lst,
    rwrd_lst,
    pnlt_lst,
  } = data;
  return {
    prjt_id,
    mainimg: prjt_thumbnail ? prjt_thumbnail : "",
    title: prjt_nm,
    finish_time: prjt_apply_st_at ? formatDate(prjt_apply_st_at, "-") : "",
    price: rcrt_lst.length > 0 ? makeComma(rcrt_lst[0].attd_amt) : 0,
    period: {
      start: rcrt_apply_st_at ? formatDate(rcrt_apply_st_at, "-") : "",
      finish: rcrt_apply_en_at ? formatDate(rcrt_apply_en_at, "-") : "",
    },
    category: prjt_ctg_cd,
    field: {
      rough: rcrt_nm_agg ? rcrt_nm_agg : "",
      detail: rcrt_lst
        ? rcrt_lst.map((item) => {
            return Object.assign(
              {
                rcrt_ctts: item.rcrt_ctts ? item.rcrt_ctts : "",
                rcrt_nm: item.rcrt_nm ? item.rcrt_nm : "",
                IUD: "U",
              },
              item
            );
          })
        : [],
    },
    leader: {
      id: leadr_usr_id ? leadr_usr_id : "",
      img: leadr_thumbnail ? leadr_thumbnail : "",
      title: leadr_ptfo_tit ? leadr_ptfo_tit : "",
      sub: leadr_brif ? leadr_brif : "",
      link: leadr_ptfo_link ? leadr_ptfo_link : "",
      name: leadr_usr_nm ? leadr_usr_nm : "",
      intro: leadr_ptfo_ctts ? leadr_ptfo_ctts : "",
    },
    pnlt_lst: pnlt_lst ? pnlt_lst : [],
    rewards: rwrd_lst ? rwrd_lst : [],
    template: prjt_ctts ? prjt_ctts : "",
  };
}

export function MagazineDataCHange(data: MeetupType, template: string) {
  const {
    mainimg,
    title,
    category,
    leader: { id, sub, name },
    link,
  } = data;

  return {
    bbs_id: "4",
    ctts_tit: title,
    ctts_ctts: template,
    ctts_ctg_cd: category,
    reader_usr_id: id,
    reader_usr_info: sub,
    thumbnail: mainimg,
    reader_nm: name,
    link,
  };
}

export function MeetupDataChange(data: MeetupType, template: string) {
  const {
    mainimg,
    title,
    price,
    finish_time,
    period: { start, finish },
    category,
    max,
    leader: { id, img, title: leaderTitle, sub, link, name, intro },
    pnlt_lst,
    address: { basic, detail },
  } = data;

  return {
    prjt_nm: title,
    prjt_thumbnail: mainimg,
    prjt_type_nm: "밋업",
    prjt_type_cd: "mtup",
    prjt_apply_st_at: new Date(finish_time),
    // prjt_apply_en_at: new Date(finish),
    prjt_ctts: template,
    mtup_usr_cnt: max,
    prjt_ctg: "mtup",
    prjt_desc: "비고",
    mtup_typ: category,
    mtup_prc: price ? price.replaceAll(",", "") : "",
    mtup_plc_basic: basic,
    mtup_plc_detail: detail,
    prjt_sort_no: 99,
    leadr_usr_id: id,
    leadr_usr_nm: name,
    leadr_brif: sub,
    leadr_thumbnail: img,
    leadr_ptfo_tit: leaderTitle,
    leadr_ptfo_ctts: intro,
    leadr_ptfo_link: link,
    pnlt_lst: pnlt_lst,
    rcrt_apply_st_at: start ? new Date(start) : "",
    rcrt_apply_en_at: finish ? new Date(finish) : "",
  };
}
export function MagazineBasicDataCHange(data: MagazineType) {
  const {
    ctts_tit,
    ctts_ctts,
    ctts_ctg_cd,
    reader_usr_id,
    reader_usr_info,
    thumbnail,
    reader_nm,
    link,
  } = data;
  return {
    mainimg: thumbnail,
    title: ctts_tit,
    template: ctts_ctts,
    category: ctts_ctg_cd,
    leader: {
      id: reader_usr_id,
      sub: reader_usr_info,
      name: reader_nm,
    },
    link,
  };
}

export function MeetupBasicDataChange(data: MeetupBasicDataType) {
  const {
    prjt_id,
    prjt_nm,
    prjt_thumbnail,

    prjt_ctts,
    prjt_apply_st_at,
    leadr_usr_id,
    mtup_prc,
    mtup_plc_basic,
    mtup_plc_detail,
    mtup_usr_cnt,
    mtup_typ,
    leadr_usr_nm,
    leadr_brif,
    leadr_thumbnail,
    leadr_ptfo_tit,
    leadr_ptfo_ctts,
    leadr_ptfo_link,
    rcrt_apply_st_at,
    rcrt_apply_en_at,
    pnlt_lst,
  } = data;

  return {
    prjt_id,
    mainimg: prjt_thumbnail ? prjt_thumbnail : "",
    title: prjt_nm,
    price: mtup_prc ? makeComma(mtup_prc) : "",
    finish_time: prjt_apply_st_at ? formatDate(prjt_apply_st_at, "-") : "",
    period: {
      start: rcrt_apply_st_at ? formatDate(rcrt_apply_st_at, "-") : "",
      finish: rcrt_apply_en_at ? formatDate(rcrt_apply_en_at, "-") : "",
    },
    max: mtup_usr_cnt ? mtup_usr_cnt : 0,
    address: {
      basic: mtup_plc_basic ? mtup_plc_basic : "",
      detail: mtup_plc_detail ? mtup_plc_detail : "",
    },
    category: mtup_typ,
    leader: {
      id: leadr_usr_id ? leadr_usr_id : "",
      img: leadr_thumbnail ? leadr_thumbnail : "",
      title: leadr_ptfo_tit ? leadr_ptfo_tit : "",
      sub: leadr_brif ? leadr_brif : "",
      link: leadr_ptfo_link ? leadr_ptfo_link : "",
      name: leadr_usr_nm ? leadr_usr_nm : "",
      intro: leadr_ptfo_ctts ? leadr_ptfo_ctts : "",
    },
    pnlt_lst: pnlt_lst ? pnlt_lst : [],
    template: prjt_ctts ? prjt_ctts : "",
  };
}

export const PrjtCategory = {
  dev: "IT / SW / 개발",
  cmpgn: "비영리 / 캠페인",
  md: "언론 / 미디어",
  mrk: "마케팅",
  art: "문화예술",
  lgs: "물류 / 제조",
  svc: "서비스",
  dsgn: "디자인",
  vid: "영상 / 콘텐츠",
  esg: "사회공헌 / ESG",
  strtp: "창업 / 스타트업",
  dta: "데이터 / AI",
};
